import { render, staticRenderFns } from "./PositionsList.vue?vue&type=template&id=e9826358&"
import script from "./PositionsList.vue?vue&type=script&lang=js&"
export * from "./PositionsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports